export default {
  listItems: null,
  customSettings: null
};
